import { UserType } from "@store/graphql/helpers/types.graphql";
import { useAtom, atom } from "@libraries/jotai";

const usersAtom = atom<UserType[]>([]);
const filteredUsersAtom = atom<UserType[]>([]);

export default function useUsers() {
  const [value, setValue] = useAtom(usersAtom);
  const [filteredUsers, setFilteredUsers] = useAtom(filteredUsersAtom);

  return { value, setValue, filteredUsers, setFilteredUsers };
}
